<template>
  <v-dialog width="70%" v-model="dialog">
    <v-form ref="form" class="form-grid" @submit.prevent="subscribe">
      <v-card>
        <v-card-title>
          {{ $t('subscription.add') }}
        </v-card-title>
        <v-card-text>

          <headline>{{ $t('organization.general-information') }}</headline>
          <subscription-plan-fields v-model="form" :plans="subscriptionPlans" :col-field="9" />
        </v-card-text>

        <v-divider class="mt-6"></v-divider>

        <v-card-actions>
          <v-row class="ma-0">
            <v-col class="text-right">
              <v-btn small @click="close">
                {{ $t('cancel') }}
              </v-btn>
              <v-btn small class="ml-3" color="primary" type="submit">
                {{ $t('subscription.subscribe') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>

import SubscriptionRepository from "@repository/SubscriptionRepository";
import SubscriptionPlanFields, { blankSubscription, subscriptionBody } from "@blocks/SubscriptionPlanFields.vue";

export default {

  components: {
    SubscriptionPlanFields,
  },

  data() {
    return {
      dialog: false,
      headers: [
        {text: this.$tc('subscription.subscription-plan'), value: 'name'},
        {text: '', value: 'options', width: 200},
      ],
      subscriptionPlans: [],
      // Ni durée d'engagement ni remboursement ici : l'abonnement n'en a pas, le remboursement se règle dans les champs du modèle.
      form: blankSubscription(),
    };
  },

  props: {
    organizationId: String,
  },

  mounted() {
    this.loadData()
  },

  destroyed() {

  },

  methods: {

    open() {
      this.dialog = true
    },

    close() {
      this.dialog = false
    },

    loadData() {
      SubscriptionRepository.searchPlans({}).then(data => {
        this.subscriptionPlans = data.items
      })
    },

    subscribe() {
      if(this.$refs.form.validate()) {
        this.showLoading(true)
        const data = subscriptionBody(this.form)
        SubscriptionRepository.organizationSubscribe(this.organizationId, data).then(response => {
          this.showLoading(false)
          this.close()
          this.$emit('subscribed', response.data)
        }).catch(err => {
          this.notifyError(err)
          this.showLoading(false)
        })
      }
    }

  }
}
</script>

<style lang="scss">

</style>
